import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uu-services-graphic-links',
  templateUrl: './uu-services-graphic-links.component.html',
  styleUrls: ['./uu-services-graphic-links.component.css']
})
export class UuServicesGraphicLinksComponent implements OnInit {
  images = [
    {
      path: '../../../../assets/img/services/access_control.jpg',
      phone: '../../../../assets/img/services/access_control_phone.jpg',
      title: 'Access Control',
    },
    {
      path: '../../../../assets/img/services/ambassadors.jpg',
      phone: '../../../../assets/img/services/ambassadors_phone.jpg',
      title: 'Ambassadors',
    },
    {
      path: '../../../../assets/img/services/armed_officers.jpg',
      phone: '../../../../assets/img/services/armed_officers_phone.jpg',
      title: 'Armed Officers',
    },
    {
      path: '../../../../assets/img/services/bike_patrol.jpg',
      phone: '../../../../assets/img/services/bike_patrol_phone.jpg',
      title: 'Bike Patrol',
    },
    {
      path: '../../../../assets/img/services/boxoffice.jpg',
      phone: '../../../../assets/img/services/boxoffice_phone.jpg',
      title: 'Box Office',
    },
    {
      path: '../../../../assets/img/services/consulting.jpg',
      phone: '../../../../assets/img/services/consulting_phone.jpg',
      title: 'Consulting',
    },
    {
      path: '../../../../assets/img/services/event_security.jpg',
      phone: '../../../../assets/img/services/event_security_phone.jpg',
      title: 'Crowd Management',
    },
    {
      path: '../../../../assets/img/services/event_security2.jpg',
      phone: '../../../../assets/img/services/event_security2_phone.jpg',
      title: 'Event Security',
    },
    {
      path: '../../../../assets/img/services/usher.jpg',
      phone: '../../../../assets/img/services/usher_phone.jpg',
      title: 'Guest Services',
    },
    {
      path: '../../../../assets/img/services/parking.jpg',
      phone: '../../../../assets/img/services/parking_phone.jpg',
      title: 'Parking',
    },
    {
      path: '../../../../assets/img/services/ticket_taking.jpg',
      phone: '../../../../assets/img/services/ticket_taking_phone.jpg',
      title: 'Ticket Taking',
    },
    {
      path: '../../../../assets/img/services/crowd_management.jpg',
      phone: '../../../../assets/img/services/crowd_management_phone.jpg',
      title: 'Ushering',
    },
  ];
cellsToShow = 3;
loop = true;
size = 'contain';
  constructor() { }

  ngOnInit(): void {
  }

}
